import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/** Full-frame spinner for Remotion `renderLoading` / buffering posters. */
export function PreviewLoadingOverlay() {
  const { t } = useTranslation();
  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className="flex h-full w-full items-center justify-center bg-black"
    >
      <Loader2 className="h-8 w-8 animate-spin text-white" aria-hidden />
      <span className="sr-only">{t('projectPreview.loading')}</span>
    </div>
  );
}
